import { Component, Element, h, Host, Method, Prop, State } from '@stencil/core';
import { getCurvesFromSVGPaths, getStyle } from '../utils/utils';
export class Animate {
  constructor() {
    /**
    *  whether the svgs should be morphed
    */
    this.morph = false;
    /**
     *  the svgs to animate
     */
    this.svgs = null;
    // duration in ms
    this.duration = 250;
    this.version = '1.9.0';
    // state of the current animation
    this.state = 'begin';
    this.paths = [];
    this.forwards = [];
    this.backwards = [];
    this.debug = true;
  }
  handleTransitionEnd() {
    this.updateSVGStyles();
  }
  updateSVGStyles() {
    this.style = `svg path {  fill: ${getStyle(this.el).color} }`;
  }
  async updateStyles(styles) {
    this.style = styles;
  }
  getPathFromIcons() {
    if (!this.svgs) {
      console.warn('no "svgs" given');
      return;
    }
    let pathCount = 0;
    this.svgs.forEach((svg) => {
      if (getCurvesFromSVGPaths(svg).length > pathCount) {
        pathCount = getCurvesFromSVGPaths(svg).length;
      }
      this.paths.push(getCurvesFromSVGPaths(svg));
    });
  }
  toggleState() {
    this.state = this.state === ('forward' || 'begin') ? 'end' : 'begin';
  }
  async play() {
    if (this.state === ('forward' || 'backward')) {
      return;
    }
    clearTimeout(this.timeout);
    this.state = this.state === 'begin' ? 'forward' : 'backward';
    let activePaths = this.state === ('forward' || 'begin') ? this.forwards : this.backwards;
    activePaths.forEach(el => {
      el.beginElement();
    });
    this.timeout = setTimeout(() => this.toggleState(), this.duration - 10);
  }
  componentWillLoad() {
    this.updateSVGStyles();
    this.getPathFromIcons();
    this.style = this.styles;
  }
  render() {
    return (h(Host, null,
      h("style", null, `:host ${this.style}; `),
      h("span", null, this.svgs && this.debug && (h("span", { class: this.state },
        h("span", { class: "icon morph-container forwards" },
          h("svg", { viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" }, this.paths[0].map((path, i) => (h("path", { d: path },
            h("animate", { attributeName: "d", ref: (el) => this.forwards.push(el), begin: "indefinite", values: path + ';' + this.paths[1][i], dur: this.duration + 'ms' })))))),
        h("span", { class: "icon morph-container backwards" },
          h("svg", { viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" }, this.paths[0].map((path, i) => (h("path", { d: this.paths[1][i] },
            h("animate", { attributeName: "d", ref: (el) => this.backwards.push(el), begin: "indefinite", values: this.paths[1][i] + ';' + path, dur: this.duration + 'ms' })))))))))));
  }
  static get is() { return "c-animate"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-animate.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-animate.css"]
  }; }
  static get properties() { return {
    "morph": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "whether the svgs should be morphed"
      },
      "attribute": "morph",
      "reflect": false,
      "defaultValue": "false"
    },
    "svgs": {
      "type": "unknown",
      "mutable": false,
      "complexType": {
        "original": "string[]",
        "resolved": "string[]",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "the svgs to animate"
      },
      "defaultValue": "null"
    },
    "styles": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "styles",
      "reflect": false
    },
    "duration": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "duration",
      "reflect": false,
      "defaultValue": "250"
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'1.9.0'"
    }
  }; }
  static get states() { return {
    "style": {},
    "state": {}
  }; }
  static get methods() { return {
    "updateStyles": {
      "complexType": {
        "signature": "(styles: any) => Promise<void>",
        "parameters": [{
            "tags": [],
            "text": ""
          }],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "",
        "tags": []
      }
    },
    "play": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "",
        "tags": []
      }
    }
  }; }
  static get elementRef() { return "el"; }
}
